export default __webpack_public_path__ + "static/media/winiron.bd661f1f.jpg";